import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'
import { push } from 'connected-react-router'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  navigate: push,
}

function BigLink (props) {
  /*
   * destination: for internal react navigation
   * href: for external pages
   */

  const { children, href, navigate, destination, analyticsEvent, screenName } = props

  return (
    <a
      className={styles.bigLink}
      onClick={ () => {
        if (destination) {
          navigate({ pathname: destination })
        }
        if (analyticsEvent) {
          analyticsEvent(screenName)
        }
      } }
      href={ !destination && href ? href : null }
    >
      { children }
    </a>
  )
}

BigLink.propTypes = {
  children: PropTypes.object,
  href: PropTypes.string,
  navigate: PropTypes.func,
  destination: PropTypes.string,
  analyticsEvent: PropTypes.func,
  screenName: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToActions)(BigLink)
